import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags, gotoUrl } from "@menu/core/lib";

const WishListIcon = observer((props: ContextProps) => {
  const { wishlist } = props.context;
  const { display, url, wishListItems } = wishlist;

  if (!display) {
    return null;
  }

  const analyticTags = () => {
    const item = AnalyticsType.menu;
    const name = `header_wishlist_icon`;
    const text = "wishlist-icon";

    return getAnalyticTags({
        component_name: name,
        nav_item: item,
        nav_text: text,
        target_page_url: url
    });
}

  return (
    <span className="inbox-icon">
      <i className="icon-heart_outline" {...analyticTags()} onClick={() => gotoUrl(url)} />
      {wishListItems > 0 && <i className="unread-count wishlist-unread" />}
    </span>
  );
});

export default WishListIcon;
